import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Table } from 'reactstrap';
import Loading from '../Loading';
import GridWithForm from '../grid/GridWithForm'
import {
    getTextFilterCfg
} from '../grid/ColumnHelpers'
import { getMultiKlasifikatorsFieldCfg, getKlasifikatorsFieldCfg } from '../forms/FormHelpers'
import { getFormatterForKodif } from '../grid/ColumnHelpers'
import { addUrlQuery, showErrorMsg } from '../../actions/uiActions';
import { riskaObjektuKategorijasActions, riskaObjektuKategorijaSelected } from '../../actions/dzeramaUdensSatecesBaseiniActions';
import TieriEditor from './TieriEditor';

const getColumns = () => {
    return [
        {
            dataField: 'nosaukums_display',
            text: 'Kategorijas nosaukums',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'grupa_display',
            text: 'Grupa',
            filterCfg: getTextFilterCfg()
        }, {
            dataField: 'kriterija_tips',
            text: 'Kritērija tips',
            filterCfg: getTextFilterCfg()
        }
    ]
}

const renderTieri = (tieri, dataObj, props) => {
    if (!tieri || tieri.length === 0) {
        return <div className="text-muted">Nav konfigurēti slieksni</div>;
    }

    const sortedTieri = [...tieri].sort((a, b) => a.tier_order - b.tier_order);
    const kriterija_tips = dataObj.kriterija_tips;

    const formatValue = (tier) => {
        if (tier.zime === '-' || tier.zime === 'ir' || tier.threshold_value === null) {
            return '-';
        }
        if (kriterija_tips === 'IPATSVARS') {
            return `${(tier.threshold_value * 100).toFixed(0)}%`;
        } else if (kriterija_tips === 'ATTALUMS') {
            return `${tier.threshold_value} m`;
        }
        return tier.threshold_value;
    };

    return (
        <Table size="sm" bordered>
            <thead>
                <tr>
                    <th>Aizsargātības pakāpe</th>
                    <th>Zīme</th>
                    <th>Kritērija vērtība</th>
                    <th>Varbūtība</th>
                    <th>Sekas</th>
                </tr>
            </thead>
            <tbody>
                {sortedTieri.map((tier, index) => (
                    <tr key={tier.id || index}>
                        <td>{tier.aizsargatibas_pakape || '-'}</td>
                        <td>{tier.zime || '-'}</td>
                        <td>{formatValue(tier)}</td>
                        <td>{tier.varbutiba ?? '-'}</td>
                        <td>{tier.sekas ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

const getFormFieldCfgs = ({ kodif }) => {
    return [
        {
            name: 'nosaukums',
            label: 'Kategorijas nosaukums (sistēmas)',
            required: true,
            readOnly: true
        }, {
            name: 'nosaukums_display',
            label: 'Attēlojamais nosaukums',
            required: true
        }, {
            ...getKlasifikatorsFieldCfg(kodif, 'RISK_KAT_GRUPA'),
            name: 'klasifikators',
            label: 'Riska kategoriju grupa',
            required: true
        }, {
            name: 'display_order',
            label: 'Secība grupā',
            type: 'number',
            readOnly: true
        }, {
            name: 'kriterija_tips',
            label: 'Kritērija tips',
            required: true,
            readOnly: true,
            type: 'radio',
            options: kodif.riskaKategorijuKriterijaTips,
            renderer: getFormatterForKodif(kodif.riskaKategorijuKriterijaTips)
        }, {
            name: 'plaisaino_varbutiba',
            label: 'Varbūtība plaisano iežu gadījumā',
            type: 'number',
            fieldNotes: 'Jāaizpilda tikai tad, ja varbūtību nosaka plaisaino iežu tips.'
        }, {
            name: 'kriterija_apraksts',
            label: 'Kritērija apraksts'
        }, {
            name: 'piezimes',
            label: 'Piezīmes',
            type: 'textarea'
        }, {
            ...getMultiKlasifikatorsFieldCfg(kodif, 'RISK_PARAM'),
            name: 'risk_params',
            label: 'Saistītie riska parametri'
        }, {
            name: 'tieri',
            label: 'Sliekšņu konfigurācija',
            customField: TieriEditor,
            renderer: renderTieri,
            extraFieldProps: { kodif }
        }
    ]
}

class RiskaKategorijas extends Component {

    render() {

        const { riskaObjektuKategorijas, kodif } = this.props

        if (!riskaObjektuKategorijas || riskaObjektuKategorijas.loading) {
            return (<Loading />)
        }

        if (!this.columns) {
            this.columns = getColumns()
        }

        if (!this.formFieldCfgs) {
            this.formFieldCfgs = getFormFieldCfgs({ kodif })
        }

        return (
            <div className="saraksts-wrapper">
                <GridWithForm
                    {...this.props}
                    columns={this.columns}
                    formFieldCfgs={this.formFieldCfgs}
                    storeObj={riskaObjektuKategorijas}
                    formWidthGuiOption="riska_objektu_kategorijas_form_width"
                    metadataFormCfg="riska_objektu_kategorijas_edit"
                    tiesibasLabot="SATECES_BASEINI_KATEGORIJAS_LABOT"
                />
            </div>
        )
    }

}


const mapStateToProps = ({ riskaObjektuKategorijas, kodif, location }) => ({ riskaObjektuKategorijas, kodif, query: location.query })

export default connect(mapStateToProps, {
    selectedAct: riskaObjektuKategorijaSelected,
    addUrlQuery,
    ...riskaObjektuKategorijasActions,
    showErrorMsg
})(RiskaKategorijas)